type QuestionIndexProps = {
  questionNumber?: string;
};

export function QuestionIndex({ questionNumber }: QuestionIndexProps) {
  if (!questionNumber) return null;

  return (
    <small className="body-sm tw:-mb-5" role="doc-subtitle">
      {questionNumber}
    </small>
  );
}
